import { els } from "./dom";

type PanelId = string;
type RenderCallback = () => void;

const PANEL_TITLES: Record<string, string> = {
  dashboard: "Dashboard",
  entry: "Add Project",
  matrix: "Asset Matrix",
  booking: "Launch Booking",
  "booking-matrix": "Booking Matrix",
  admin: "Admin",
};

const panelCallbacks = new Map<PanelId, RenderCallback>();
let activePanel: PanelId = "dashboard";

/**
 * Returns the currently active panel ID.
 */
export function getActivePanel(): PanelId {
  return activePanel;
}

/**
 * Register a render callback for a panel.
 * Called when that panel becomes active via navigateTo.
 */
export function onPanelActivate(panelId: PanelId, callback: RenderCallback): void {
  panelCallbacks.set(panelId, callback);
}

/**
 * Switch the active panel and invoke its render callback.
 */
export function navigateTo(tab: string): void {
  activePanel = tab;

  for (const nav of els.navItems) {
    nav.classList.toggle("is-active", nav.dataset.tab === tab);
  }

  for (const panel of els.panels) {
    panel.classList.toggle("is-active", panel.id === tab);
  }

  if (els.pageTitle) {
    els.pageTitle.textContent = PANEL_TITLES[tab] || "Dashboard";
  }

  const cb = panelCallbacks.get(tab);
  if (cb) cb();
}

/**
 * Bind click handlers on sidebar navigation items.
 */
export function bindNavigation(): void {
  for (const nav of els.navItems) {
    nav.addEventListener("click", () => {
      if (nav.classList.contains("hidden")) {
        return;
      }
      const key = nav.dataset.tab;
      if (key) navigateTo(key);
    });
  }
}
